/**
 * Google accounts allowed to use the Content Manager when no `admins/{uid}` doc exists.
 * Prefer adding long-term admins in Firestore (Firebase Console) when possible.
 */
const ADMIN_EMAILS_LOWER = new Set(
  ['itayberi@gmail.com', 'razibeeri@gmail.com'].map((e) => e.toLowerCase()),
);

export function isAllowlistedAdminEmail(email: string | null | undefined): boolean {
  if (!email) return false;
  return ADMIN_EMAILS_LOWER.has(email.trim().toLowerCase());
}
